/**
 * Fintum wordmark used on every unauthenticated / onboarding surface.
 *
 * The SVG is the abstract "stacked waves" mark used on the login page;
 * keep it inline (rather than an external asset) so the page renders
 * the brand even when the network or CDN is slow. ``Market Intelligence``
 * is the product-name tag that pairs with the wordmark.
 *
 * Default placement: absolute top-5 left-5 inside the page container —
 * matches the auth layout. Pass a ``className`` to override.
 */

interface Props {
  className?: string;
}

export function BrandMark({ className }: Props) {
  return (
    <div
      className={
        className
        ?? "absolute top-5 left-5 flex items-center gap-3"
      }
    >
      <svg
        viewBox="13 16 486 486"
        className="h-9 w-9 text-accent"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g transform="translate(256, 300) scale(1.8)">
          <path
            d="M-135,55 C-95,42 -50,20 0,-100 C50,20 95,42 135,55 C90,44 48,23 0,-85 C-48,23 -90,44 -135,55 Z"
            fill="currentColor"
            opacity="0.35"
          />
          <path
            d="M-115,48 C-80,36 -40,16 0,-80 C40,16 80,36 115,48 C76,38 38,19 0,-65 C-38,19 -76,38 -115,48 Z"
            fill="currentColor"
            opacity="0.5"
          />
          <path
            d="M-95,40 C-65,30 -32,12 0,-60 C32,12 65,30 95,40 C62,32 30,15 0,-47 C-30,15 -62,32 -95,40 Z"
            fill="currentColor"
            opacity="0.7"
          />
          <path
            d="M-74,32 C-50,24 -24,9 0,-42 C24,9 50,24 74,32 C48,26 22,11 0,-30 C-22,11 -48,26 -74,32 Z"
            fill="currentColor"
            opacity="0.85"
          />
          <path
            d="M-54,24 C-36,17 -16,5 0,-25 C16,5 36,17 54,24 C34,19 15,8 0,-15 C-15,8 -34,19 -54,24 Z"
            fill="currentColor"
            opacity="1"
          />
        </g>
      </svg>
      <div className="flex items-baseline gap-1.5">
        <span className="text-lg font-semibold tracking-tight text-text-primary">
          Fintum
        </span>
        <span className="text-sm font-medium text-text-tertiary">
          Market Intelligence
        </span>
      </div>
    </div>
  );
}
